<mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
    <mat-tab label="Business Domains"></mat-tab>
    <mat-tab label="Create Business Domain"></mat-tab>
</mat-tab-group>

<div style="margin-top: 1rem">
    <router-outlet></router-outlet>
</div>
